import React from "react";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import "./hello-bar.scss";
import { useEffect, useState } from "react";
import Text from "../text/Text";

const HelloBar = ({
  descriptionText,
  color,
  besideComponent = null,
  startIcon,
  id,
  hide,
  fontColor,
  sx,
}) => {
  const [textColor, setTextColor] = useState(fontColor || "#fff");
  const content = (
    <Box
      className="hellobar-wrapper"
      sx={{ background: color, ...(sx && sx) }}
      id={id}
      display={hide ? "none !important" : "flex !important"}
    >
      <Text
        variant="body1"
        font="regular"
        className="desc-text"
        size={14}
        sx={{ color: textColor }}
        withIcon={startIcon ? "start" : ""}
      >
        {startIcon}
        {descriptionText}
      </Text>
      <Box
        className="beside-component content-center"
        sx={{ color: textColor }}
      >
        {besideComponent}
      </Box>
    </Box>
  );
  return (
    <Slide direction="down" in={true}>
      {content}
    </Slide>
  );
};

export default HelloBar;
